import { compareAsc } from "date-fns";
import { IAnomalyEvent, ITextAnomalyEvent } from "@edgetier/watchtower-types";

/**
 * From an array of events, get all the phrases of an text anomaly event.
 * @param anomalyEvents Events inside an anomaly.
 * @returns             Array of phrases.
 */
export const getAnomalyPhrases = (anomalyEvents: IAnomalyEvent[]) => {
    return anomalyEvents
        .sort((one, two) => compareAsc(one.detectDateTime, two.detectDateTime))
        .filter((anomalyEvent): anomalyEvent is ITextAnomalyEvent => "phrase" in anomalyEvent.details)
        .map(({ details }) => details.phrase)
        .filter((phrase, index, phrases) => phrases.indexOf(phrase) === index);
};
